
export const actionTypes = {
  SET_PET_NAME: "SET_PET_NAME",
  SET_PET_ID: "SET_PET_ID",
  SET_RETIRE_REASON: "SET_RETIRE_REASON",
  SET_REASON_DESCRIPTION: "SET_REASON_DESCRIPTION",
  SET_DELETED_STATUS: "SET_DELETED_STATUS",
};

const setPetName = (petName: string) => ({
  type: actionTypes.SET_PET_NAME,
  payload: petName,
});
const setPetId = (petId: string) => ({
  type: actionTypes.SET_PET_ID,
  payload: petId,
});
const setRetireReason = (retireReason: string) => ({
  type: actionTypes.SET_RETIRE_REASON,
  payload: retireReason,
});
const setReasonDescription = (reasonText: string) => ({
  type: actionTypes.SET_REASON_DESCRIPTION,
  payload: reasonText,
});
const setDeletedStatus = (status: boolean) => ({
  type: actionTypes.SET_DELETED_STATUS,
  payload: status,
});

export default {
  setPetName,
  setPetId,
  setRetireReason,
  setReasonDescription,
  setDeletedStatus,
};
